import React, { useEffect, useState } from 'react';
import { useButton, useI18n, useLogger, useSelector } from '~Hooks';
import Icon from '~ComponentsImproved/Icon';
import PrinterIcon from '~Assets/icons/print.svg';
import Modal from '~ComponentsImproved/Modal';
import { ModalContent } from '../styles';
import styled from '@emotion/styled';
import FailedPrints from '~Components/PrinterStatus/FailedPrints';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';

const Wrapper = styled.div`
  border: 1px solid red;
  background-color: var(--colorBlueGray1100);
  position: fixed;
  z-index: 10;
  bottom: 48px;
  left: 12px;
  border-radius: 3px;
  box-shadow: 1px 1px 10px 2px rgba(0, 0, 0, 0.7);
  color: white;
`;

const InnerWrapper = styled.div`
  padding: 10px;
  position: relative;
`;

const Alert = styled.div`
  font-size: 24px;
  margin-right: 10px;
  border-radius: 100%;
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: red;
  top: -10px;
  right: -20px;
  font-weight: bold;
  font-size: 12px;
  text-align: center;
`;

export const RemoveButton = styled.div`
  font-size: 8px;
  color: #e88;
  margin: 0 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FailedPrintsAlert = () => {
  const logger = useLogger('printer');
  const { i18n } = useI18n();
  const [expanded, setExpanded] = useState(false);

  const handlers = useButton({
    onClick: () => {
      setExpanded(true);
    },
  });

  const printErrors = useSelector((state) =>
    state.POSPrintQueue.filter((print) => Boolean(print.error)),
  );

  useEffect(() => {
    if (printErrors.length > 0) {
      logger.info('There are print errors in the queue', {
        count: printErrors.length,
        printErrors: printErrors,
      });
    }
  }, [printErrors]);

  if (!printErrors.length) {
    return null;
  }

  return (
    <Wrapper>
      <InnerWrapper {...handlers}>
        <Icon src={PrinterIcon} color={'red'} />

        <Alert>!</Alert>
      </InnerWrapper>

      <Modal isShowing={expanded} hide={() => setExpanded(false)}>
        <ModalContent>
          <Paragraph level={4} color="var(--colorWhite)">
            {i18n('Printer.Status.FailedPrints')}:
          </Paragraph>

          <FailedPrints />
        </ModalContent>
      </Modal>
    </Wrapper>
  );
};

export default FailedPrintsAlert;
